import ArrowCircleLeftIcon from "@mui/icons-material/ArrowBack";
import ManageBreakDownModel from "../Breakdowns/ManageBreakDown";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const Header = () => {
  const history = useHistory();
  return (
    <div className="top">
      <button
        className="saveBtn1 mr-3"
        onClick={() => history.push("/schooladmindata")}
      >
        <ArrowCircleLeftIcon className="mx-1 addIconSc" />
        Back To Home
      </button>
      <div className="topRight">
        <ManageBreakDownModel />
      </div>
    </div>
  );
};

export default Header;
